import { Data, TransformsList } from 'cio/utils/analytics/transforms';

const Transforms: TransformsList = {
  base(data: Data & { comment: Record<string, any> }) {
    return {
      'Comment Type': 'Email',
      'Comment ID': data.comment.commentId,
      'Comment Content': data.comment.comment.content.substr(0, 150),
    };
  },

  withoutContent(data: Data & { comment: Record<string, any> }) {
    return {
      'Comment Type': 'Email',
      'Comment ID': data.comment.commentId,
    };
  },

  replied(data: Data & { comment: Record<string, any> }) {
    return {
      'Comment Type': 'Email',
      'Comment ID': data.comment.comment.parentCommentId,
      'Comment Content': data.comment.comment.content.substr(0, 150),
    };
  },

  edited(data: Data & { comment: Record<string, any> }) {
    return {
      'Comment Type': 'Email',
      'Comment ID': data.comment.commentId,
      'Comment Content': data.comment.update.content.substr(0, 150),
    };
  },
};

export default Transforms;
